import { verticalKnot } from 'src/features/brands/treasure/canvas/common/back/lace/webKnots'
import { listStraightLittle, listStraightThumb } from 'src/features/brands/treasure/canvas/glove/back/lace/listCross'
import { State } from 'src/types'
import { edgeOfBeltBackStyle, edgeOfBeltBackStyleWithThumbOver } from 'src/features/brands/treasure/canvas/catchermitt/back/edge'
import { listCross } from 'src/features/brands/treasure/canvas/catchermitt/back/lace/listCross'
import { thumbOverBelt } from 'src/features/brands/treasure/canvas/catchermitt/back/backStyleDrawer/treasureBelt/thumbOverBelt'
import { treasureBeltDrawer } from 'src/features/brands/treasure/canvas/catchermitt/back/backStyleDrawer/treasureBelt/treasureBeltDrawer'

export const beltTypeDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const isThumbOver = state.beltType?.value === 'thumbOver'
  // 親指上載せタイプ
  if (isThumbOver) {
    thumbOverBeltTypeDrawer(ctx, state)
  }
  // 親指上載せタイプ以外
  if (!isThumbOver) {
    normalBeltTypeDrawer(ctx, state)
  }

  // 結び目のレース
  verticalKnot(ctx, state.lace.color, 105, 185, 1) // ベルト結び目
}

const normalBeltTypeDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  treasureBeltDrawer(ctx, state)
  edgeOfBeltBackStyle(ctx, state.edge.color, state.stitch.color)
  listCross(ctx, state.lace.color)
}

const thumbOverBeltTypeDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  thumbOverBelt(ctx, state.listBelt.color)
  edgeOfBeltBackStyleWithThumbOver(ctx, state.edge.color, state.stitch.color)
  listStraightLittle(ctx, state.lace.color, -25, 50)
  listStraightLittle(ctx, state.lace.color, -30, 90)
  listStraightThumb(ctx, state.lace.color, -25, 45)
  listStraightThumb(ctx, state.lace.color, -33, 80)
}
